import Entity from './entity'
export default class Inairthreshold extends Entity<number>{
    tName:string;
}